export const globalEndpoints = (builder, path, name, tags) => ({
  [`getAll${name}`]: builder.query({
    query: (params) => ({
      url: `/${path}`,
      method: "GET",
      params,
    }),
    providesTags: [name],
  }),

  [`getById${name}`]: builder.query({
    query: ({ id, params = {} }) => ({
      url: `/${path}/${id}`,
      method: "GET",
      params,
    }),
    providesTags: [name],
  }),

  [`create${name}`]: builder.mutation({
    query: (body) => ({
      url: `/${path}`,
      method: "POST",
      body,
    }),
    invalidatesTags: [name, ...tags],
  }),

  [`update${name}`]: builder.mutation({
    query: ({ id, body }) => ({
      url: `/${path}/${id}`,
      method: "PUT",
      body,
    }),
    invalidatesTags: [name, ...tags],
  }),

  [`delete${name}`]: builder.mutation({
    query: (id) => ({
      url: `/${path}/${id}`,
      method: "DELETE",
    }),
    invalidatesTags: [name, ...tags],
  }),

  //   [`updateMany${name}`]: builder.mutation({
  //     query: ({ params, body }) => ({
  //       url: `/${path}/update-many`,
  //       method: "PUT",
  //       body,
  //       params,
  //     }),
  //     invalidatesTags: [name, ...tags],
  //   }),

  //   // ! need to update latter
  //   [`deleteMany${name}`]: builder.mutation({
  //     query: (ids) => {
  //       return {
  //         url: `/${path}/delete-many`,
  //         method: "POST",
  //         body: { ids },
  //       };
  //     },
  //     invalidatesTags: [name, ...tags],
  //   }),
});
